import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { ErrorReporter } from "@/utils/errorReporting";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    ErrorReporter.warn(`404: ${location.pathname}`, {
      component: 'NotFound',
      action: 'page_not_found',
      metadata: { pathname: location.pathname }
    });
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-gray-600">Oops! Page not found</p>
        <a href="/" className="text-blue-500 underline hover:text-blue-700">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
